import React, { useState, useMemo } from "react";
import "./index.css";
import section2img from "../assests/HomeImg/section2-img.svg";
import adobe from "../assests/policiesImages/file-icon.svg";

// import p1 from "../assests/viyash_pdf/policies-1.pdf"
// import p2 from "../assests/viyash_pdf/policies-2.pdf"
// import p3 from "../assests/viyash_pdf/policies-3.pdf"
// import p4 from "../assests/viyash_pdf/policies-4.pdf"
// import p5 from "../assests/viyash_pdf/policies-5.pdf"
// import p6 from "../assests/viyash_pdf/policies-6.pdf"
// import p7 from "../assests/viyash_pdf/policies-7.pdf"
// import p8 from "../assests/viyash_pdf/policies-8.pdf"
// import p9 from "../assests/viyash_pdf/policies-9.pdf"
// import p10 from "../assests/viyash_pdf/policies-10.pdf"
// import p11 from "../assests/viyash_pdf/policies-11.pdf"
// import p12 from "../assests/viyash_pdf/policies-12.pdf"
// import p13 from "../assests/viyash_pdf/policies-13.pdf"
// import p14 from "../assests/viyash_pdf/policies-14.pdf"
// import p15 from "../assests/viyash_pdf/policies-15.pdf"
// import p16 from "../assests/viyash_pdf/policies-16.pdf"
// import p17 from "../assests/viyash_pdf/policies-17.pdf"
// import p18 from "../assests/viyash_pdf/policies-18.pdf"
// import p19 from "../assests/viyash_pdf/policies-19.pdf"
// import p20 from "../assests/viyash_pdf/policies-20.pdf"

// // ── Financials 2023-2024 ───────────────────────────────────────────────────
// import p21 from "../assests/viyash_pdf/Vila-Vina-Participacions-S.L.-FY-23-24.pdf"
// import p22 from "../assests/viyash_pdf/Topkim-Topkapi-ilac-Premiks-Sanayi-Ve-Ticaret-Anonik-Sirketi-FY-23-24.pdf"
// import p23 from "../assests/viyash_pdf/Phytotherapic-Solutions-S.-L.-FY-23-24.pdf"
// import p24 from "../assests/viyash_pdf/Fendigo-SA-Belgium-FY-23-24.pdf"
// import p25 from "../assests/viyash_pdf/Topkim-March-2024-Full-set-V2.signed.pdf"
// import p26 from "../assests/viyash_pdf/VVP-Stat-Financials-Q4-FY23-24-signed.pdf"
// import p27 from "../assests/viyash_pdf/Phyto-Stat-Financials-Q4-FY23-24-signed.pdf"
// import p28 from "../assests/viyash_pdf/Kz-Spain-Stat-Financials-Q4-FY23-24-signed.pdf"
// import p29 from "../assests/viyash_pdf/Kz-Mexico-Stat-Financials-Q4-FY23-24-signed.pdf"
// import p30 from "../assests/viyash_pdf/Bremer-Pharma-GMBH-Germany-FY-23-24.pdf"
// import p31 from "../assests/viyash_pdf/Alivira-Italia-S.R.L-Ltda.-FY-23-24.pdf"
// import p32 from "../assests/viyash_pdf/N-vet-FS-FY-23-24.pdf"
// import p33 from "../assests/viyash_pdf/Provet-March-2024-Full-set-V2.signed.pdf"
// import p34 from "../assests/viyash_pdf/Financials-Sequent-Scientific-ESOP-trust-FY-2023-24.pdf"
// import p35 from "../assests/viyash_pdf/Fendigo-BV-FS-FY-23-24-1.pdf"
// import p36 from "../assests/viyash_pdf/Expeden-Financials-Mar-24.pdf"
// import p37 from "../assests/viyash_pdf/Alivira-USA-FS-FY-23-24.pdf"
// import p38 from "../assests/viyash_pdf/Alivira-UK-Mar24.pdf"
// import p39 from "../assests/viyash_pdf/Alivira-Saude-Financials-Mar-24.pdf"
// import p40 from "../assests/viyash_pdf/Alivira-Ireland-FS-FY-23-24.pdf"
// import p41 from "../assests/viyash_pdf/Alivira-Brazil-Financials-Mar-24.pdf"
// import p42 from "../assests/viyash_pdf/AAHL, India FS FY-2024.pdf"
// import p43 from "../assests/viyash_pdf/SRL FS FY-2024.pdf"

// // ── Financials 2022-2023 ───────────────────────────────────────────────────
// import p44 from "../assests/viyash_pdf/Alivira Animal Health Limited India Financial Mar22.pdf"
// import p45 from "../assests/viyash_pdf/SeQuent Research Limited Financial Mar' 22.pdf"
// import p46 from "../assests/viyash_pdf/Alivira ireland Mar'23.pdf"
// import p47 from "../assests/viyash_pdf/Alivira Italy 31.03.2023.pdf"
// import p48 from "../assests/viyash_pdf/Alivira Brasil Financials Mar'23_signed.pdf"
// import p49 from "../assests/viyash_pdf/Alivira Saúde Financials Mar'23_signed.pdf"
// import p50 from "../assests/viyash_pdf/Bremer Pharma 31.03.2023.pdf"
// import p51 from "../assests/viyash_pdf/Fendigo bv.pdf"
// import p52 from "../assests/viyash_pdf/Fendigo SA 31.03.2023.pdf"
// import p53 from "../assests/viyash_pdf/Evanvet Financials Mar'23_signed.pdf"
// import p54 from "../assests/viyash_pdf/Alivira US FS.pdf"
// import p55 from "../assests/viyash_pdf/Alivira Animal Health UK Ltd -YE 31.03.2023-V2.pdf"
// import p56 from "../assests/viyash_pdf/Kz Mexico Stat Financials Q4 FY22-23 signed v.2.pdf"
// import p57 from "../assests/viyash_pdf/Kz Spain Stat Financials Q4 FY22-23 signed.pdf"
// import p58 from "../assests/viyash_pdf/N VET.pdf"
// import p59 from "../assests/viyash_pdf/Phyto Stat Financials Q4 FY22-23 signed.pdf"
// import p60 from "../assests/viyash_pdf/Covivet Stat Financials Q4 FY22-23 signed.pdf"
// import p61 from "../assests/viyash_pdf/PROVET-Mar'23.pdf"
// import p62 from "../assests/viyash_pdf/TOPKİM Mar'23.pdf"
// import p63 from "../assests/viyash_pdf/VVP Stat Financials Q4 FY22-23 signed.pdf"

// // ── Financials 2021-2022 ───────────────────────────────────────────────────
// import p64 from "../assests/viyash_pdf/Alivira Animal Health Limited India Financial Mar22.pdf"
// import p65 from "../assests/viyash_pdf/SeQuent Research Limited Financial Mar' 22.pdf"
// import p66 from "../assests/viyash_pdf/Alivira Animal Health Limited Ireland Financial Mar'22.pdf"
// import p67 from "../assests/viyash_pdf/Alivira France SAS Financial Mar'22.pdf"
// import p68 from "../assests/viyash_pdf/Alivira Italia SRL Financial Mar'22.pdf"
// import p69 from "../assests/viyash_pdf/Alivira Saude Animal Brasil Participacoes Ltda Financial Mar'22.pdf"
// import p70 from "../assests/viyash_pdf/Alivira Saude Animal Ltda Financial Mar'22.pdf"
// import p71 from "../assests/viyash_pdf/Bremer Pharma GMBH Financial Mar'22.pdf"
// import p72 from "../assests/viyash_pdf/Fendigo BV Financial Mar'22.pdf"
// import p73 from "../assests/viyash_pdf/Fendigo SA Financial Mar'22.pdf"
// import p74 from "../assests/viyash_pdf/Evanvet Distribuidora De Produtos Veterinarios Ltda Financial Mar'22.pdf"
// import p75 from "../assests/viyash_pdf/Alivira Animal Health USA LLC Financial Mar'22.pdf"
// import p76 from "../assests/viyash_pdf/Alivira Animal Health UK Ltd Financial Mar'22.pdf"
// import p77 from "../assests/viyash_pdf/Laboratorios Karizoo, S.A. DE C.V. (Mexico) Financial Mar'22.pdf"
// import p78 from "../assests/viyash_pdf/Laboratorios Karizoo, S.A Financial Mar'22.pdf"
// import p79 from "../assests/viyash_pdf/N-Vet Financial Mar'22.pdf"
// import p80 from "../assests/viyash_pdf/Phytotherapic Solutions S.L Financial Mar'22.pdf"
// import p81 from "../assests/viyash_pdf/Provet Veteriner Ürünleri San. Ve Tic. A. Ş  Mar'22.pdf"
// import p82 from "../assests/viyash_pdf/Topkim Topkapi İlaç Premiks Sanayl Ve Ticaret. A. Ş Financials Mar'22.pdf"
// import p83 from "../assests/viyash_pdf/Nourrie Saude e Nutricao Animal Ltda Financial as on Mar'22.pdf"
// import p84 from "../assests/viyash_pdf/Vila Viña Participacions S.L Financial Mar'22.pdf"

// // ── Financials 2020-2021 ───────────────────────────────────────────────────
// import p85 from "../assests/viyash_pdf/Alivira Animal Health Limited India Financial Mar'21.pdf"
// import p86 from "../assests/viyash_pdf/SeQuent Research Limited Financial Mar'21.pdf"
// import p87 from "../assests/viyash_pdf/Elysian Life Sciences Pvt. Ltd Financial Mar'21.pdf"
// import p88 from "../assests/viyash_pdf/Alivira Animal Health Limited Ireland Financial Mar21.pdf"
// import p89 from "../assests/viyash_pdf/Alivira France SAS Financial Mar21.pdf"
// import p90 from "../assests/viyash_pdf/Alivira Italia SRL Financial Mar21.pdf"
// import p91 from "../assests/viyash_pdf/Alivira Brazil Financial Mar21.pdf"
// import p92 from "../assests/viyash_pdf/Bremer Pharma GMBH Financial Mar21.pdf"
// import p93 from "../assests/viyash_pdf/Evance Saude Animal Ltda Mar'21 Final_Signed.pdf"
// import p94 from "../assests/viyash_pdf/Fendigo BV Financial Mar21.pdf"
// import p95 from "../assests/viyash_pdf/Fendigo SA Financial Mar'21.pdf"
// import p96 from "../assests/viyash_pdf/Evanvet Distribidora Productos Veterinarios Ltda Financial Mar'21.pdf"
// import p97 from "../assests/viyash_pdf/Alivira Animal Health USA LLC  Financial Mar'21.pdf"
// import p98 from "../assests/viyash_pdf/Alivira Animal Health UK Ltd Financial Mar'21.pdf"
// import p99 from "../assests/viyash_pdf/Laboratorios Karizoo, S.A. DE C.V. (Mexico) Financial Mar21.pdf"
// import p100 from "../assests/viyash_pdf/Laboratorios Karizoo, S.AFinancial Mar21.pdf"

// ── Corporate Policies ───────────────────────────────────────────────────────
// import pol_1 from "../assests/policies/Sequent-Scientific-Limited-Employee-Stock-option-Plan-2020.pdf"
// import pol_2 from "../assests/policies/POLICY OF PREVENTION OF SEXUAL HARASSMENT OF WOMEN (POSH).pdf"
// import pol_3 from "../assests/policies/Corporate-Social-Responsibility-CSR-Policy-1.pdf"
// import pol_4 from "../assests/policies/ANTI-DISCRIMINATION POLICY.pdf"
// import pol_5 from "../assests/policies/8.-Viyash_Board-Diversity-Policy.pdf"
// import pol_6 from "../assests/policies/10.-Viyash_Code-of-Conduct-for-Prohibition-of-Insider-Trading.pdf"
// import pol_7 from "../assests/policies/3.-Whistle-Blower-Policy.pdf"
// import pol_8 from "../assests/policies/9.-Code-of-Conduct-for-fair-Disclosure-of-Unpublished-Price-Sensitive-Information.pdf"
// import pol_9 from "../assests/policies/EHS Policy.pdf"
// import pol_10 from "../assests/policies/4.-Viyash-Policy-on-Preservation-and-Archival-of-Documents-1.pdf"
// import pol_11 from "../assests/policies/5.-Viyash_Dividend_Distribution_Policy.pdf"
// import pol_12 from "../assests/policies/6.-Viyash_Policy-on-Director-Appointment-and-Remuneration.pdf"
// import pol_13 from "../assests/policies/11.-Viyash-Policy-on-Determination-of-Materiality-for-Disclosure-of-Events-or-Information.pdf"
// import pol_14 from "../assests/policies/1.-Policy-on-Determination-of-Material-Subsidiaries.pdf"
// import pol_15 from "../assests/policies/5.-Related-Party-Transactions.pdf"
// import pol_16 from "../assests/policies/7.-Risk-Management-Policy.pdf"

import pol_1 from "../assests/policies/policy-related-party-transactions.pdf";
import pol_2 from "../assests/policies/policy-material-subsidiaries.pdf";
import pol_3 from "../assests/policies/policy-materiality-disclosure-events.pdf";
import pol_4 from "../assests/policies/risk-management-policy.pdf";
import pol_5 from "../assests/policies/policy-director-appointment-remuneration.pdf";
import pol_6 from "../assests/policies/dividend-distribution-policy.pdf";
import pol_7 from "../assests/policies/policy-preservation-archival-documents.pdf";
import pol_8 from "../assests/policies/code-conduct-upsi-disclosure.pdf";
import pol_9 from "../assests/policies/whistle-blower-policy.pdf";
import pol_10 from "../assests/policies/code-conduct-insider-trading.pdf";
import pol_11 from "../assests/policies/board-diversity-policy.pdf";
import pol_12 from "../assests/policies/policy-harassment-discrimination.pdf";
import pol_13 from "../assests/policies/csr-policy.pdf";
import pol_14 from "../assests/policies/posh-policy.pdf";
import pol_15 from "../assests/policies/esop-policy-2020.pdf";
import pol_16 from "../assests/policies/code-conduct-board-directors.pdf";
import pol_17 from "../assests/policies/independent-directors-familiarization-program.pdf";
import pol_18 from "../assests/policies/independent-directors-terms-conditions.pdf";

// ── Code of Conduct ──────────────────────────────────────────────────────────
import coc_1 from "../assests/codeConduct/Code of Conduct & Ethics_Board of Directors.pdf"
import coc_2 from "../assests/codeConduct/Sequent - Supplier Code of Conduct.pdf"
import coc_3 from "../assests/codeConduct/2.-Code-of-Conduct-Ethics_Board-of-Directors.pdf"

// ── Independent Directors ────────────────────────────────────────────────────
import ind_1 from "../assests/independent/Familarization_Programme_2022-2023.pdf"
import ind_2 from "../assests/independent/Terms & Conditions of Independent Directors.pdf"
import ind_3 from "../assests/independent/Familarization_Programme_2023-2024.pdf"

// ── SVG Icons ────────────────────────────────────────────────────────────────

import boardImg1 from "../assests/boardOfDirectors_images/Image-1.png";
import boardImg2 from "../assests/boardOfDirectors_images/Image-2.png";
import boardImg3 from "../assests/boardOfDirectors_images/Image-3.png";
import boardImg4 from "../assests/boardOfDirectors_images/Image-4.png";
import boardImg5 from "../assests/boardOfDirectors_images/Image-5.png";
import boardImg6 from "../assests/boardOfDirectors_images/Image-6.png";
import boardImg7 from "../assests/boardOfDirectors_images/Image-7.png";

const boardOfDirectors = [
    { image: boardImg1, name: "Dr. Kamal Sharma", role: "Chairman & Independent Director", description: "Dr. Kamal Sharma has over 48 years of professional experience in executive positions in the Chemical and Pharmaceutical industries and has essayed a wide variety of roles in operations, corporate development and executive management. As the Managing Director of Lupin for a decade between 2003-13, he was instrumental in Lupin achieving leadership position in key markets and businesses, transforming it into one of the largest and fastest growing pharmaceutical companies globally. Previously, he also served as President & Chief Executive of the Life Sciences and speciality group and Member of the Management Board at RPG Enterprises. Mr. Sharma received a Bachelors Degree in Chemical Engineering from IIT Kanpur, a post graduate diploma in Industrial Management from Jamnalal Bajaj Institute of Management Studies and a PhD in Economics from IIT, Mumbai. He has also attended Advanced Management Program (AMP) at Harvard Business School, Boston." },
    { image: boardImg2, name: "Dr. Haribabu Bodepudi", role: "Managing Director & Group CEO", description: "Dr. Hari Babu Bodepudi holds a PhD degree in Organic Chemistry from Andhra University and has over 30 years of Industry experience permeating diverse roles in Research, Manufacturing, Quality and operations in both APIs and Oral Solids. During the last 20 years, he held several leadership roles in technical and commercial operations in Mylan Laboratories, including being the COO of Mylan India, CEO of Mylan India and the Global COO of Mylan. He was responsible for more than 50 Mylan facilities and managing more than 200 APIs and 15000 SKUs of different formulations. At Mylan, he led Mylan's foray into the ARV business and grew that business to over USD 800mn with global leadership (in volume, value and portfolio spread) and more than 50% market share. He has hands-on experience in global supply chain, regulatory, API R&D, quality and Commercial operations." },
    { image: boardImg3, name: "Mr. Rajaram Narayanan", role: "Executive Director and CEO – Animal Health", description: "With over 25 years of experience, Mr. Narayanan has a strong track record of leading revenue and profitability growth across multiple industries including pharmaceuticals. He joins from Sanofi India Limited, where he was the Managing Director and Country Chair for India. At Sanofi, he led the strategic reorientation of its India business operations, resulting in accelerated growth in key therapies and significant transformation of Sanofi's market operations. Before this, he was Chief Marketing Officer at Airtel, India's leading telecommunications company. Mr. Narayanan started his career at Hindustan Unilever Ltd., where he held various leadership roles in India and other Asian markets for over 18 years, building and managing many iconic consumer brands. Mr. Narayanan holds a Degree of BE (Hons)-Electrical & Electronics from Birla Institute of Technology and Science, Pilani, and MBA from Indian Institute of Foreign Trade, New Delhi. He has completed the Advanced Management Program from Harvard Business School, USA." },
    { image: boardImg4, name: "Mr. Srinivas Vasireddy", role: "Executive Director", description: "Mr. Srinivas Vasireddy brings 37 years of extensive experience across all facets of API operations. His expertise spans Manufacturing, PPIC, Third-Party Manufacturing, and driving improvements in Quality, Compliance, and EHS standards. Prior to joining the Company, he served as Head of API (Special Projects) at Mylan Laboratories, where he played a key role in managing critical projects and ensuring operational excellence. His career reflects a strong focus on optimizing processes, enhancing compliance, and delivering sustainable improvements across API operations. He holds a B.Sc. degree from Nagarjuna University." },
    { image: boardImg5, name: "Mr. Anuj Poddar", role: "Non-Executive Director", description: "Anuj Poddar is a Managing Director and Asia Co-Head of Global Portfolio Solutions at Carlyle, the leading global investment firm with USD 450 billion of assests under management. In his role, Mr. Poddar works closely with Carlyle Asia's investment advisory teams to oversee value creation strategies and to help drive transformational change and performance with portfolio companies, focusing on India, Australia and South-East Asia. Prior to this, he was the Managing Director and Chief Executive Officer of Bajaj Electricals, India's leading Consumer Products and Lighting Solutions company (with an erstwhile Power EPC business which was spun off). He is credited with having driven transformation of the company in a relatively short period, that resulted in significant turnaround of performance and value creation for all stakeholders. Prior to Bajaj Electricals, he was a member of the Leadership Team at Viacom18 Media and one of its key founding team members. During his over 13 years with the company he played an integral role in the growth of the company. He also led strategy for MTV Networks Asia, based out of Singapore. Prior to Viacom18 Media, Anuj spent nearly a decade with Arthur Andersen and KPMG and was involved in a range of consulting, mergers & acquisitions and assurance services to varied clients across sectors. He is an Aspen Fellow, Trustee of the Ananta Centre, member of various committees of CII (Confederation of Indian Industry), member of The Trilateral Commission and a member of BMW Foundation's World Responsible Leaders' Network. Anuj is a rank-holding Chartered Accountant and lives in Mumbai, India." },
    // { image: fabianImg, name: "Dr. Fabian Kausche", role: "Non Executive Director", description: "Dr. Kausche is a Chairman of the Board of PetMedix, Cambridge. Dr. Kausche also owns and runs FK Consulting, LLC, Atlanta. He has several decades of experience in the animal and human health industries in both biological and pharmaceutical research and development. He held subsequent positions as Global Head of R&D for Novartis Animal Health, Merial, and Boehringer Ingelheim Animal Health. Worked in the human health space as head of R&D for Novartis Consumer Health. Prior to that, he also successfully led a companion animal sales force for Novartis Animal Health. Dr. Kausche received a veterinary degree from the Hannover Veterinary School. He subsequently completed a Master's of Science degree at Iowa State University. Following the completion of the M.S. degree, Having completed the Advanced Management Program in 2005, he is also an alumnus of Harvard Business School." },
    // { image: greogoryImg, name: "Mr. Gregory Andrews", role: "Non-executive Director", description: "Greg is a multi-disciplinary executive with 30 years of commercial experience in the pharmaceutical industry. He is a dynamic business leader who creates a positive impact on the business environment through change and active engagement of both internal and external stakeholders. Currently Greg is a global animal health consultant with offices in the USA and France. He previously held executive positions within three of the major animal health companies where he gained global experience living and working in Australia, Belgium, France and the USA. Marketing, communications and management are core disciplines for Greg. He has led many marketing teams in the USA and Europe and most recently was the Global Marketing Director for Virbac. Greg headed global Public Affairs and Policy for Pfizer Animal Health during its IPO transition to Zoetis. He has also held numerous senior management roles including country management for Belgium and the Netherlands and was Vice President for emerging markets in Europe, Africa, Middle East, Russia and CIS. Greg received a Bachelor of Science (Hons) from Monash University, Australia and Post Graduate Diplomas in both Business Management and International Relations from the University of Tasmania, Australia." },
    { image: boardImg6, name: "Mr. Milind Sarwate", role: "Independent Director", description: "Milind Sarwate is the Founder & CEO of Increate Value Advisors LLP. \"Increate\" means \"Uncreated\" or \"Undiscovered\". Milind set up Increate in 2015 as his second career as an entrepreneur, to help organizations & individuals discover, develop & deliver business & social value. For this, he contributes as required - as Advisor, Mentor, Board Member, or Investor, leveraging his 37-year experience including long stints in Marico & Godrej. His Advisory roles in Business Value Creation encompass the following: Helping Private Equity Investors enhance Investee Companies’ value, especially in Consumer / Retail Sectors, across listed and unlisted companies; mentoring promoters and corporate professionals for effective Promotership & Governance; capability building and enhancing effectiveness of Corporate functions, like Finance, HR & Strategy; and maximizing value in IPOs / M&As / Corporate Structuring. His Advisory roles in Social Value Creation cover: guiding companies in CSR strategy and execution, helping non-profit organizations grow and widen their social impact, and being the middleware between the Social Sector and the Corporate Business sector. His directorships include 5 listed companies - Mahindra Finance, Hexaware, Glenmark, Metropolis, Matrimony.com - and 3 unlisted companies - OmniActive Health Technologies, Eternis Fine Chemicals and WheelsEMI, all with focus on the audit committee. He also plays Advisory Board role in Bruhat Insights Global, a start-up in Artificial Intelligence in HR, and Educo, a School Support NGO. He invests in promising business / social enterprises (largely SMEs), by way of venture and angel capital. He has been awarded ICAI CFO Award (2011), CNBC TV-18 CFO Award (2012) & CFO India Hall of Fame induction (2013). Milind is a Chartered Accountant, Cost Accountant, Company Secretary and Commerce Graduate. He is a CII-Fulbright Fellow (Carnegie Mellon University, USA)." },
    { image: boardImg7, name: "Ms. Revati Kasture", role: "Independent Director", description: "Revati Kasture has over two decades of experience in ratings and research. She is currently the Executive Director (under organization nomenclature) of Care Ratings Limited and CEO of CareEdge Global IFSC Limited (CGIL), a wholly owned subsidiary of Care Ratings. Prior to this she was heading the Criteria and Policy Department at CARE Ratings which entailed development of rating criteria, policy and rating models, process improvements as well as interacting with regulators. In the span of her career, she has managed multiple departments within CARE including the large corporate ratings, incubation and scale-up of industry research department making it a profit Centre." }
];

const committeesData = [
    {
        title: "I. Audit Committee",
        members: [
            { id: 1, name: "Mr. Milind Shripad Sarwate", role: "Independent Director, Chairman" },
            { id: 2, name: "Dr. Kamal Kishore Sharma", role: "Independent Director, Member" },
            { id: 3, name: "Mr. Anuj Poddar", role: "Non-Executive Director, Member" },
            { id: 4, name: "Ms. Revati Parag Kasture", role: "Independent Director, Member" },
        ],
    },
    {
        title: "II. Nomination and Remuneration Committee",
        members: [
            { id: 1, name: "Mr. Milind Sarwate", role: "Chairman" },
            { id: 2, name: "Dr. Kamal Sharma", role: "Member" },
            { id: 3, name: "Mr. Anuj Poddar", role: "Member" },
        ],
    },
    {
        title: "III. Stakeholders Relationship Committee",
        members: [
            { id: 1, name: "Ms. Revati Parag Kasture", role: "Independent Director, Chairperson" },
            { id: 2, name: "Mr. Milind Shripad Sarwate", role: "Independent Director, Member" },
            { id: 3, name: "Mr. Rajaram Narayanan", role: "Managing Director, Member" },
            { id: 4, name: "Dr. Haribabu Bodepudi", role: "Managing Director & Group CEO" },
        ],
    },
    {
        title: "IV. Corporate Social Responsibility Committee",
        members: [
            { id: 1, name: "Dr. Kamal Sharma", role: "Chairman" },
            { id: 2, name: "Mr. Rajaram Narayanan", role: "Member" },
            { id: 3, name: "Dr. Hari Babu Bodepudi", role: "Member" },
        ],
    },
    {
        title: "V. Risk Management Committee",
        members: [
            { id: 1, name: "Mr. Anuj Poddar", role: "Chairman" },
            { id: 2, name: "Mr. Milind Sarwate", role: "Member" },
            { id: 3, name: "Mr. Rajaram Narayanan", role: "Member" },
            { id: 4, name: "Dr. Haribabu Bodepudi", role: "Member" },
            { id: 5, name: "Ms. Revati Kasture", role: "Member" },
            { id: 6, name: "Mr. Ramakant Singani", role: "Member" },
        ],
    },
    {
        title: "Committees of the Board of Alivira Animal Health Limited",
        isFullWidth: true,
        members: [],
    },
    {
        title: "I. Corporate Social Responsibility Committee",
        isFullWidth: true,
        members: [
            { id: 1, name: "Dr. Kamal Sharma", role: "Chairman" },
            { id: 2, name: "Mr. Rajaram Narayanan", role: "Member" },
            { id: 3, name: "Mr. Srinivas Vasireddy", role: "Member" },
        ],
    }
];

const PdfIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" fill="#E53935" opacity="0.15" />
        <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="#E53935" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <path d="M14 2V8H20" stroke="#E53935" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 13H15M9 17H13" stroke="#E53935" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

const DownloadIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 15V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const CalendarIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
        <path d="M16 2V6M8 2V6M3 10H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const FilterIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const SearchIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2" />
        <path d="M21 21L16.65 16.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const CorporateGovernance = () => {
    const [activeTab, setActiveTab] = useState("Policies");
    const [selectedCompany, setSelectedCompany] = useState("Subsidiary Financial");
    const [selectedYear, setSelectedYear] = useState("All");
    const [selectedDirector, setSelectedDirector] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");

    // const reports = [
    //     { id: 1, name: "SRL Signed FS FY-25", year: 2025, link: p1 },
    //     { id: 2, name: "AAHL, India FS FY-2025", year: 2025, link: p2 },
    //     { id: 3, name: "ESOP Trust FS FY 2025", year: 2025, link: p3 },
    //     { id: 4, name: "Alivira UK FS FY 2024-25", year: 2025, link: p4 },
    //     { id: 5, name: "Alivira USA FS FY 2024-25", year: 2025, link: p5 },
    //     { id: 6, name: "Alivira Italia Financials 2024-25", year: 2025, link: p6 },
    //     { id: 7, name: "BREMER Pharma FS FY 2024-25", year: 2025, link: p7 },
    //     { id: 8, name: "Phytotherapic Solutions S.L FS FY 2024-25", year: 2025, link: p8 },
    //     { id: 9, name: "Laboratorios Karizoo, S.A. DE C.V. FS FY 2024-25", year: 2025, link: p9 },
    //     { id: 10, name: "Laboratories Karizoo Spain FS FY 2024-25", year: 2025, link: p10 },
    //     { id: 11, name: "Vila Viña Participacions S.L. FS FY 2024-25", year: 2025, link: p11 },
    //     { id: 12, name: "Expeden_FS FY 2024-25", year: 2025, link: p12 },
    //     { id: 13, name: "Alivira Saude Animal Ltda. FS FY-2024-25", year: 2025, link: p13 },
    //     { id: 14, name: "N-Vet AB FS FY 2024-25", year: 2025, link: p14 },
    //     { id: 15, name: "Fendingo BV FS FY 2024-25", year: 2025, link: p15 },
    //     { id: 16, name: "Alivira Saude Animal Brasil Participacoes Ltda FS FY 2024-25", year: 2025, link: p16 },
    //     { id: 17, name: "Fendingo SA FS FY 2024-25", year: 2025, link: p17 },
    //     { id: 18, name: "Topkim Topkapi Ilaç premiks Sanayi Ve Ticaret A.Ş FS FY 2024-25", year: 2025, link: p18 },
    //     { id: 19, name: "Provet Veteriner Ürünleri San. Ve Tic. A. Ş.FS FY 2024-25", year: 2025, link: p19 },
    //     { id: 20, name: "Alivira Animal Health Limited, Ireland FS FY-2024-25", year: 2025, link: p20 },

    //     // 2024 (23 items)
    //     { id: 21, name: "Vila Viña Participacions S.L. FY 23-24", year: 2024, link: p21 },
    //     { id: 22, name: "Topkim Topkapi ilac Premiks Sanayi Ve Ticaret Anonik Sirketi FY 23-24", year: 2024, link: p22 },
    //     { id: 23, name: "Phytotherapic Solutions S. L. FY 23-24", year: 2024, link: p23 },
    //     { id: 24, name: "Fendigo SA Belgium FY 23-24", year: 2024, link: p24 },
    //     { id: 25, name: "Topkim March 2024 Full set V2.signed", year: 2024, link: p25 },
    //     { id: 26, name: "VVP Stat Financials Q4 FY23-24 signed", year: 2024, link: p26 },
    //     { id: 27, name: "Phyto Stat Financials Q4 FY23-24 signed", year: 2024, link: p27 },
    //     { id: 28, name: "Bremer Pharma GMBH Germany FY 23-24", year: 2024, link: p30 },
    //     { id: 29, name: "Alivira Italia S.R.L. Ltda. FY 23-24", year: 2024, link: p31 },
    //     { id: 30, name: "N-vet FS FY 23-24", year: 2024, link: p32 },
    //     { id: 31, name: "Kz Spain Stat Financials Q4 FY23-24 signed", year: 2024, link: p28 },
    //     { id: 32, name: "Provet March 2024 Full set V2.signed", year: 2024, link: p33 },
    //     { id: 33, name: "Kz Mexico Stat Financials Q4 FY23-24 signed", year: 2024, link: p29 },
    //     { id: 34, name: "Financials Sequent Scientific ESOP trust FY 2023-24", year: 2024, link: p34 },
    //     { id: 35, name: "Fendigo BV FS FY 23-24", year: 2024, link: p35 },
    //     { id: 36, name: "Expeden Financials Mar-24", year: 2024, link: p36 },
    //     { id: 37, name: "Alivira USA FS FY 23-24", year: 2024, link: p37 },
    //     { id: 38, name: "Alivira UK Mar'24", year: 2024, link: p38 },
    //     { id: 39, name: "Alivira Saúde Financials Mar-24", year: 2024, link: p39 },
    //     { id: 40, name: "Alivira Ireland FS FY 23-24", year: 2024, link: p40 },
    //     { id: 41, name: "Alivira Brazil Financials Mar-24", year: 2024, link: p41 },
    //     { id: 42, name: "Alivira Animal Health Limited 2023-24", year: 2024, link: p42 },
    //     { id: 43, name: "Sequent Research Limited 2023-24", year: 2024, link: p43 },

    //     // 2023 (20 items)
    //     { id: 44, name: "Alivira Animal Health Limited 2022-23", year: 2023, link: p44 },
    //     { id: 45, name: "Sequent Research Limited 2022-23", year: 2023, link: p45 },
    //     { id: 46, name: "Alivira Animal Health Limited, Ireland Financial Mar'23", year: 2023, link: p46 },
    //     { id: 47, name: "Alivira Italia SRL Financial Mar'23", year: 2023, link: p47 },
    //     { id: 48, name: "Alivira Saude Animal Brasil Participacoes Ltda Financial Mar'23", year: 2023, link: p48 },
    //     { id: 49, name: "Alivira Saude Animal Ltda Financial Mar'23", year: 2023, link: p49 },
    //     { id: 50, name: "Bremer Pharma GMBH Financial Mar'23", year: 2023, link: p50 },
    //     { id: 51, name: "Fendigo BV Financial Mar'23", year: 2023, link: p51 },
    //     { id: 52, name: "Fendigo SA Financial Mar'23", year: 2023, link: p52 },
    //     { id: 53, name: "Evanvet Distribuidora De Produtos Veterinarios Ltda Financial Mar'23", year: 2023, link: p53 },
    //     { id: 54, name: "Alivira Animal Health USA LLC Financial Mar'23", year: 2023, link: p54 },
    //     { id: 55, name: "Alivira Animal Health UK Ltd Financial Mar'23", year: 2023, link: p55 },
    //     { id: 56, name: "Laboratorios Karizoo, S.A. DE C.V. (Mexico) Financial Mar'23", year: 2023, link: p56 },
    //     { id: 57, name: "Laboratorios Karizoo, S.A Financial Mar'23", year: 2023, link: p57 },
    //     { id: 58, name: "N-Vet Financial Mar'23", year: 2023, link: p58 },
    //     { id: 59, name: "Phytotherapic Solutions S.L Financial Mar'23", year: 2023, link: p59 },
    //     { id: 60, name: "Covivet Stat Financials Q4 FY22-23 signed", year: 2023, link: p60 },
    //     { id: 61, name: "Provet Veteriner Ürünleri San. Ve Tic. A. Ş Mar'23", year: 2023, link: p61 },
    //     { id: 62, name: "Topkim Topkapi İlaç Premiks Sanayl Ve Ticaret. A. Ş Financials Mar'23", year: 2023, link: p62 },
    //     { id: 63, name: "Vila Viña Participacions S.L Financial Mar'23", year: 2023, link: p63 },

    //     // 2022 (21 items)
    //     { id: 64, name: "Alivira Animal Health Limited 2021-22", year: 2022, link: p64 },
    //     { id: 65, name: "Sequent Research Limited 2021-22", year: 2022, link: p65 },
    //     { id: 66, name: "Alivira Animal Health Limited, Ireland Financial Mar'22", year: 2022, link: p66 },
    //     { id: 67, name: "Alivira France SAS Financial Mar'22", year: 2022, link: p67 },
    //     { id: 68, name: "Alivira Italia SRL Financial Mar'22", year: 2022, link: p68 },
    //     { id: 69, name: "Alivira Saude Animal Brasil Participacoes Ltda Financial Mar'22", year: 2022, link: p69 },
    //     { id: 70, name: "Alivira Saude Animal Ltda Financial Mar'22", year: 2022, link: p70 },
    //     { id: 71, name: "Bremer Pharma GMBH Financial Mar'22", year: 2022, link: p71 },
    //     { id: 72, name: "Fendigo BV Financial Mar'22", year: 2022, link: p72 },
    //     { id: 73, name: "Fendigo SA Financial Mar'22", year: 2022, link: p73 },
    //     { id: 74, name: "Evanvet Distribuidora De Produtos Veterinarios Ltda Financial Mar'22", year: 2022, link: p74 },
    //     { id: 75, name: "Alivira Animal Health USA LLC Financial Mar'22", year: 2022, link: p75 },
    //     { id: 76, name: "Alivira Animal Health UK Ltd Financial Mar'22", year: 2022, link: p76 },
    //     { id: 77, name: "Laboratorios Karizoo, S.A. DE C.V. (Mexico) Financial Mar'22", year: 2022, link: p77 },
    //     { id: 78, name: "Laboratorios Karizoo, S.A Financial Mar'22", year: 2022, link: p78 },
    //     { id: 79, name: "N-Vet Financial Mar'22", year: 2022, link: p79 },
    //     { id: 80, name: "Phytotherapic Solutions S.L Financial Mar'22", year: 2022, link: p80 },
    //     { id: 81, name: "Provet Veteriner Ürünleri San. Ve Tic. A. Ş Mar'22", year: 2022, link: p81 },
    //     { id: 82, name: "Topkim Topkapi İlaç Premiks Sanayl Ve Ticaret. A. Ş Financials Mar'22", year: 2022, link: p82 },
    //     { id: 83, name: "Nourrie Saude e Nutricao Animal Ltda Financial as on Mar'22", year: 2022, link: p83 },
    //     { id: 84, name: "Vila Viña Participacions S.L Financial Mar'22", year: 2022, link: p84 },

    //     // 2021 (15 items)
    //     { id: 85, name: "Alivira Animal Health Limited 2020-21", year: 2021, link: p85 },
    //     { id: 86, name: "Sequent Research Limited 2020-21", year: 2021, link: p86 },
    //     { id: 87, name: "Elysian Life Sciences Private Limited 2020-21", year: 2021, link: p87 },
    //     { id: 88, name: "Alivira Animal Health Limited, Ireland", year: 2021, link: p88 },
    //     { id: 89, name: "Alivira France SAS", year: 2021, link: p89 },
    //     { id: 90, name: "Alivira Italia SRL", year: 2021, link: p90 },
    //     { id: 91, name: "Alivira Saude Animal Brasil Participacoes Ltda", year: 2021, link: p91 },
    //     { id: 92, name: "Bremer Pharma GMBH", year: 2021, link: p92 },
    //     { id: 93, name: "Evance Saude Animal LTDA", year: 2021, link: p93 },
    //     { id: 94, name: "Fendigo BV", year: 2021, link: p94 },
    //     { id: 95, name: "Fendigo SA", year: 2021, link: p95 },
    //     { id: 96, name: "Evanvet Distribidora Productos Veterinarios Ltda", year: 2021, link: p96 },
    //     { id: 97, name: "Alivira Animal Health USA LLC", year: 2021, link: p97 },
    //     { id: 98, name: "Alivira Animal Health UK Ltd", year: 2021, link: p98 },
    //     { id: 99, name: "Laboratorios Karizoo, S.A. DE C.V. (Mexico)", year: 2021, link: p99 },
    //     { id: 100, name: "Laboratorios Karizoo, S.A.", year: 2021, link: p100 }
    // ];

    const sequentResearch = [
        // { name: "Sequent Research Limited 2023-24", year: "2023-2024", type: "FY", url: p43 },
        // { name: "Sequent Research Limited 2022-23", year: "2022-2023", type: "FY", url: p45 },
        // { name: "Sequent Research Limited 2021-22", year: "2021-2022", type: "FY", url: p65 },
        // { name: "Sequent Research Limited 2020-21", year: "2020-2021", type: "FY", url: p86 },
        { name: "Sequent Research Limited 2019-20", year: "2019-2020", type: "FY" },
        { name: "Sequent Research Limited 2018-19", year: "2018-2019", type: "FY" },
        { name: "Sequent Research Limited 2017-18", year: "2017-2018", type: "FY" },
        { name: "Sequent Research Limited 2016-17", year: "2016-2017", type: "FY" },
        { name: "Sequent Research Limited 2015-16", year: "2015-2016", type: "FY" },
        { name: "Sequent Research Limited 2014-15", year: "2014-2015", type: "FY" }
    ];
    const sequentPharmaceuticals = [
        { name: "Sequent Pharmaceuticals Private Limited 2017-18", year: "2017-2018", type: "FY" },
        { name: "Sequent Pharmaceuticals Private Limited 2016-17", year: "2016-2017", type: "FY" },
        { name: "Sequent Pharmaceuticals Private Limited 2015-16", year: "2015-2016", type: "FY" },
        { name: "Sequent Pharmaceuticals Private Limited 2014-15", year: "2014-2015", type: "FY" }
    ];
    const sequentAntibiotics = [
        { name: "Sequent Anti Biotics Private Limited 2017-18", year: "2017-2018", type: "FY" },
        { name: "Sequent Anti Biotics Private Limited 2016-17", year: "2016-2017", type: "FY" },
        { name: "Sequent Anti Biotics Private Limited 2015-16", year: "2015-2016", type: "FY" },
        { name: "Sequent Anti Biotics Private Limited 2014-15", year: "2014-2015", type: "FY" }
    ];
    // const foreignSubsidiaries = [
    // 2023-24
    // { name: "Vila Viña Participacions S.L. FY 23-24", year: "2023-2024", type: "FY", url: p21 },
    // { name: "Topkim Topkapi ilac Premiks Sanayi Ve Ticaret Anonik Sirketi FY 23-24", year: "2023-2024", type: "FY", url: p22 },
    // { name: "Phytotherapic Solutions S. L. FY 23-24", year: "2023-2024", type: "FY", url: p23 },
    // { name: "Fendigo SA Belgium FY 23-24", year: "2023-2024", type: "FY", url: p24 },
    // { name: "Topkim March 2024 Full set V2.signed", year: "2023-2024", type: "FY", url: p25 },
    // { name: "Bremer Pharma GMBH Germany FY 23-24", year: "2023-2024", type: "FY", url: p30 },
    // { name: "Alivira Italia S.R.L. Ltda. FY 23-24", year: "2023-2024", type: "FY", url: p31 },
    // { name: "N-vet FS FY 23-24", year: "2023-2024", type: "FY", url: p32 },
    // { name: "Provet March 2024 Full set V2.signed", year: "2023-2024", type: "FY", url: p33 },
    // { name: "Financials Sequent Scientific ESOP trust FY 2023-24", year: "2023-2024", type: "FY", url: p34 },
    // { name: "Fendigo BV FS FY 23-24", year: "2023-2024", type: "FY", url: p35 },
    // { name: "Expeden Financials Mar-24", year: "2023-2024", type: "FY", url: p36 },
    // { name: "Alivira USA FS FY 23-24", year: "2023-2024", type: "FY", url: p37 },
    // { name: "Alivira UK Mar’24", year: "2023-2024", type: "FY", url: p38 },
    // { name: "Alivira Saúde Financials Mar-24", year: "2023-2024", type: "FY", url: p39 },
    // { name: "Alivira Ireland FS FY 23-24", year: "2023-2024", type: "FY", url: p40 },
    // { name: "Alivira Brazil Financials Mar-24", year: "2023-2024", type: "FY", url: p41 },

    // 2022-23
    //     { name: "Covivet Stat Financials Q4 FY22-23 signed", year: "2022-2023", type: "Q4", url: p60 },
    //     { name: "Alivira Animal Health Limited, Ireland Financial Mar’23", year: "2022-2023", type: "FY", url: p46 },
    //     { name: "Alivira Italia SRL Financial Mar’23", year: "2022-2023", type: "FY", url: p47 },
    //     { name: "Alivira Saude Animal Brasil Participacoes Ltda Financial Mar’23", year: "2022-2023", type: "FY", url: p48 },
    //     { name: "Alivira Saude Animal Ltda Financial Mar’23", year: "2022-2023", type: "FY", url: p49 },
    //     { name: "Bremer Pharma GMBH Financial Mar’23", year: "2022-2023", type: "FY", url: p50 },
    //     { name: "Fendigo BV Financial Mar’23", year: "2022-2023", type: "FY", url: p51 },
    //     { name: "Fendigo SA Financial Mar’23", year: "2022-2023", type: "FY", url: p52 },
    //     { name: "Evanvet Distribuidora De Produtos Veterinarios Ltda Financial Mar’23", year: "2022-2023", type: "FY", url: p53 },
    //     { name: "Alivira Animal Health USA LLC Financial Mar’23", year: "2022-2023", type: "FY", url: p54 },
    //     { name: "Alivira Animal Health UK Ltd Financial Mar’23", year: "2022-2023", type: "FY", url: p55 },
    //     { name: "Laboratorios Karizoo, S.A. DE C.V. (Mexico) Financial Mar’23", year: "2022-2023", type: "FY", url: p56 },
    //     { name: "Laboratorios Karizoo, S.A Financial Mar’23", year: "2022-2023", type: "FY", url: p57 },
    //     { name: "N-Vet Financial Mar’23", year: "2022-2023", type: "FY", url: p58 },
    //     { name: "Phytotherapic Solutions S.L Financial Mar’23", year: "2022-2023", type: "FY", url: p59 },
    //     { name: "Provet Veteriner Ürünleri San. Ve Tic. A. Ş Mar’23", year: "2022-2023", type: "FY", url: p61 },
    //     { name: "Topkim Topkapi İlaç Premiks Sanayl Ve Ticaret. A. Ş Financials Mar’23", year: "2022-2023", type: "FY", url: p62 },
    //     { name: "Vila Viña Participacions S.L Financial Mar’23", year: "2022-2023", type: "FY", url: p63 },

    //     // 2021-22
    //     { name: "Alivira Animal Health Limited, Ireland Financial Mar’22", year: "2021-2022", type: "FY", url: p66 },
    //     { name: "Alivira France SAS Financial Mar’22", year: "2021-2022", type: "FY", url: p67 },
    //     { name: "Alivira Italia SRL Financial Mar’22", year: "2021-2022", type: "FY", url: p68 },
    //     { name: "Alivira Saude Animal Brasil Participacoes Ltda Financial Mar’22", year: "2021-2022", type: "FY", url: p69 },
    //     { name: "Alivira Saude Animal Ltda Financial Mar’22", year: "2021-2022", type: "FY", url: p70 },
    //     { name: "Bremer Pharma GMBH Financial Mar’22", year: "2021-2022", type: "FY", url: p71 },
    //     { name: "Fendigo BV Financial Mar’22", year: "2021-2022", type: "FY", url: p72 },
    //     { name: "Fendigo SA Financial Mar’22", year: "2021-2022", type: "FY", url: p73 },
    //     { name: "Evanvet Distribuidora De Produtos Veterinarios Ltda Financial Mar’22", year: "2021-2022", type: "FY", url: p74 },
    //     { name: "Alivira Animal Health USA LLC Financial Mar’22", year: "2021-2022", type: "FY", url: p75 },
    //     { name: "Alivira Animal Health UK Ltd Financial Mar’22", year: "2021-2022", type: "FY", url: p76 },
    //     { name: "Laboratorios Karizoo, S.A. DE C.V. (Mexico) Financial Mar’22", year: "2021-2022", type: "FY", url: p77 },
    //     { name: "Laboratorios Karizoo, S.A Financial Mar’22", year: "2021-2022", type: "FY", url: p78 },
    //     { name: "N-Vet Financial Mar’22", year: "2021-2022", type: "FY", url: p79 },
    //     { name: "Phytotherapic Solutions S.L Financial Mar’22", year: "2021-2022", type: "FY", url: p80 },
    //     { name: "Provet Veteriner Ürünleri San. Ve Tic. A. Ş Mar’22", year: "2021-2022", type: "FY", url: p81 },
    //     { name: "Topkim Topkapi İlaç Premiks Sanayl Ve Ticaret. A. Ş Financials Mar’22", year: "2021-2022", type: "FY", url: p82 },
    //     { name: "Nourrie Saude e Nutricao Animal Ltda Financial as on Mar’22", year: "2021-2022", type: "FY", url: p83 },
    //     { name: "Vila Viña Participacions S.L Financial Mar’22", year: "2021-2022", type: "FY", url: p84 },

    //     // 2020-21
    //     { name: "Alivira Animal Health Limited, Ireland", year: "2020-2021", type: "FY", url: p88 },
    //     { name: "Alivira France SAS", year: "2020-2021", type: "FY", url: p89 },
    //     { name: "Alivira Italia SRL", year: "2020-2021", type: "FY", url: p90 },
    //     { name: "Alivira Saude Animal Brasil Participacoes Ltda", year: "2020-2021", type: "FY", url: p91 },
    //     { name: "Bremer Pharma GMBH", year: "2020-2021", type: "FY", url: p92 },
    //     { name: "Evance Saude Animal LTDA", year: "2020-2021", type: "FY", url: p93 },
    //     { name: "Fendigo BV", year: "2020-2021", type: "FY", url: p94 },
    //     { name: "Fendigo SA", year: "2020-2021", type: "FY", url: p95 },
    //     { name: "Evanvet Distribuidora Productos Veterinarios Ltda", year: "2020-2021", type: "FY", url: p96 },
    //     { name: "Alivira Animal Health USA LLC", year: "2020-2021", type: "FY", url: p97 },
    //     { name: "Alivira Animal Health UK Ltd", year: "2020-2021", type: "FY", url: p98 },
    //     { name: "Laboratorios Karizoo, S.A. DE C.V. (Mexico)", year: "2020-2021", type: "FY", url: p99 },
    //     { name: "Laboratorios Karizoo, S.A.", year: "2020-2021", type: "FY", url: p100 },
    //     { name: "N-VET AB", year: "2020-2021", type: "FY" },
    //     { name: "Phytotherapic Solutions S.L", year: "2020-2021", type: "FY" },
    //     { name: "Provet Veteriner Ürünleri San. Ve Tic. A. Ş.", year: "2020-2021", type: "FY" },
    //     { name: "Topkim İlaç Premiks San. ve Tic. A. Ş.", year: "2020-2021", type: "FY" },
    //     { name: "Veterinaria De Lleida S.L", year: "2020-2021", type: "FY" },
    //     { name: "Vila Viña Participacions S.L.", year: "2020-2021", type: "FY" },
    //     // Older
    //     { name: "Alivira Animal Health Limited, Ireland", year: "2019-2020", type: "FY" },
    //     { name: "Alivira France SAS", year: "2019-2020", type: "FY" },
    //     { name: "Alivira Italia SRL", year: "2019-2020", type: "FY" },
    //     { name: "Alivira Saude Animal Brasil Participacoes Ltda", year: "2019-2020", type: "FY" },
    //     { name: "Bremer Pharma GMBH", year: "2019-2020", type: "FY" },
    //     { name: "Evance Saude Animal LTDA", year: "2019-2020", type: "FY" },
    //     { name: "Fendigo BV", year: "2019-2020", type: "FY" },
    //     { name: "Fendigo SA", year: "2019-2020", type: "FY" },
    //     { name: "Interchange Veterinária Indústria E Comércio Ltda.", year: "2019-2020", type: "FY" },
    //     { name: "Laboratorios Karizoo, S.A. DE C.V. (Mexico)", year: "2019-2020", type: "FY" },
    //     { name: "Laboratorios Karizoo, S.A.", year: "2019-2020", type: "FY" },
    //     { name: "N-VET AB", year: "2019-2020", type: "FY" },
    //     { name: "Phytotherapic Solutions S.L", year: "2019-2020", type: "FY" },
    //     { name: "Provet Veteriner Ürünleri San. Ve Tic. A. Ş.", year: "2019-2020", type: "FY" },
    //     { name: "Topkim İlaç Premiks San. ve Tic. A. Ş.", year: "2019-2020", type: "FY" },
    //     { name: "Vila Viña Participacions S.L.", year: "2019-2020", type: "FY" },

    //     { name: "Alivira Animal Health Limited, Ireland", year: "2018-2019", type: "FY" },
    //     { name: "Alivira France SAS", year: "2018-2019", type: "FY" },
    //     { name: "Alivira Italia SRL", year: "2018-2019", type: "FY" },
    //     { name: "Aliviria Saude Animal Brasil Participacoes Ltda", year: "2018-2019", type: "FY" },
    //     { name: "Bremer Pharma GMBH", year: "2018-2019", type: "FY" },
    //     { name: "Covivet", year: "2018-2019", type: "FY" },
    //     { name: "Evance Saude Animal LTDA", year: "2018-2019", type: "FY" }
    // ];
    // const elysianLifeSciences = [
    //     { name: "Elysian Life Sciences Private Limited 2020-21", year: "2020-2021", type: "FY", url: p87 },
    //     { name: "Elysian Life Sciences Private Limited 2019-20", year: "2019-2020", type: "FY" },
    //     { name: "Elysian Life Sciences Private Limited 2018-19", year: "2018-2019", type: "FY" },
    //     { name: "Elysian Life Sciences Private Limited 2017-18", year: "2017-2018", type: "FY" },
    //     { name: "Elysian Life Sciences Private Limited 2016-17", year: "2016-2017", type: "FY" },
    //     { name: "Elysian Life Sciences Private Limited 2015-16", year: "2015-2016", type: "FY" },
    //     { name: "Elysian Life Sciences Private Limited 2014-15", year: "2014-2015", type: "FY" }
    // ];
    // const aliviraAnimalHealth = [
    //     { name: "Alivira Animal Health Limited 2023-24", year: "2023-2024", type: "FY", url: p42 },
    //     { name: "Alivira Animal Health Limited 2022-23", year: "2022-2023", type: "FY", url: p44 },
    //     { name: "Alivira Animal Health Limited 2021-22", year: "2021-2022", type: "FY", url: p64 },
    //     { name: "Alivira Animal Health Limited 2020-21", year: "2020-2021", type: "FY", url: p85 },
    //     { name: "Alivira Animal Health Limited 2019-20", year: "2019-2020", type: "FY" },
    //     { name: "Alivira Animal Health Limited 2018-19", year: "2018-2019", type: "FY" },
    //     { name: "Alivira Animal Health Limited 2017-18", year: "2017-2018", type: "FY" },
    //     { name: "Alivira Animal Health Limited 2016-17", year: "2016-2017", type: "FY" },
    //     { name: "Alivira Animal Health Limited 2015-16", year: "2015-2016", type: "FY" },
    //     { name: "Alivira Animal Health Limited 2014-15", year: "2014-2015", type: "FY" }
    // ];

    // const policies = [
    //     { name: "Sequent Scientific Limited Employee Stock option Plan 2020", url: pol_1 },
    //     { name: "Prevention of Sexual Harassment (PoSH) Policy", url: pol_2 },
    //     { name: "Sequent Corporate Social Responsibility Policy", url: pol_3 },
    //     { name: "Policy on Prevention of Harassment & Discrimination", url: pol_4 },
    //     { name: "Viyash Board Diversity Policy", url: pol_5 },
    //     { name: "Viyash code of conduct for prohibition of insider trading", url: pol_6 },
    //     { name: "Whistle Blower Policy", url: pol_7 },
    //     { name: "Code of Conduct for Fair Disclosure of Unpublished Price Sensitive Information", url: pol_8 },
    //     { name: "EHS Policy", url: pol_9 },
    //     { name: "Viyash Policy on Preservation and Archival of Documents", url: pol_10 },
    //     { name: "Viyash Dividend Distribution Policy", url: pol_11 },
    //     { name: "Viyash Policy on Director's Appointment and Remuneration", url: pol_12 },
    //     { name: "Viyash Policy on Determination of Materiality for Disclosure of Events or Information", url: pol_13 },
    //     { name: "Policy on Determination of Material Subsidiaries", url: pol_14 },
    //     { name: "Policy on Related Party Transactions", url: pol_15 },
    //     { name: "Risk Management Policy", url: pol_16 },
    //     { name: "Code of Conduct & Ethics for Board of Directors", url: coc_3 },
    //     { name: "Supplier Code of Conduct", url: coc_2 },
    //     { name: "Board of Directors", url: coc_1 },
    //     { name: "Familiarisation programme for Independent Director", url: ind_1 },
    //     { name: "Terms and Conditions of Independent Directors", url: ind_2 },
    //     { name: "Familiarisation programme for Independent Director 2023-2024", url: ind_3 },
    //     { name: "Code of Conduct & Ethics for Board of Directors", url: coc_3 },
    //     { name: "Supplier Code of Conduct", url: coc_2 },
    //     { name: "Board of Directors", url: coc_1 },
    //     { name: "Familiarisation programme for Independent Director", url: ind_1 },
    //     { name: "Terms and Conditions of Independent Directors", url: ind_2 },
    //     { name: "Familiarisation programme for Independent Director 2023-2024", url: ind_3 }
    // ];

    const policies = [
        { name: "Policy on Related Party Transactions", url: pol_1 },
        { name: "Policy on Determination of Material Subsidiaries", url: pol_2 },
        { name: "Policy on Determination of Materiality for Disclosure of Events or Information", url: pol_3 },
        { name: "Risk Management Policy", url: pol_4 },
        { name: "Policy on Director's Appointment and Remuneration", url: pol_5 },
        { name: "Dividend Distribution Policy", url: pol_6 },
        { name: "Policy on Preservation and Archival of Documents", url: pol_7 },
        { name: "Code of Conduct for Fair Disclosure of Unpublished Price Sensitive Information", url: pol_8 },
        { name: "Whistle Blower Policy", url: pol_9 },
        { name: "Code of Conduct for Prohibition of Insider Trading", url: pol_10 },
        { name: "Board Diversity Policy", url: pol_11 },
        { name: "Policy on Prevention of Harassment and Discrimination", url: pol_12 },
        { name: "Corporate Social Responsibility (CSR) Policy", url: pol_13 },
        { name: "Prevention of Sexual Harassment (POSH) Policy", url: pol_14 },
        { name: "Sequent ESOP Policy 2020", url: pol_15 },
        { name: "Code of Conduct and Ethics for Board of Directors", url: pol_16 },
        { name: "Familiarization Programme for Independent Directors", url: pol_17 },
        { name: "Terms and Conditions for Independent Directors", url: pol_18 }
    ];
    // const codeOfConduct = [
    //     { name: "Code of Conduct & Ethics for Board of Directors", url: coc_3 },
    //     { name: "Supplier Code of Conduct", url: coc_2 },
    //     { name: "Board of Directors", url: coc_1 }
    // ];
    // const Independent = [
    //     { name: "Familiarisation programme for Independent Director", url: ind_1 },
    //     { name: "Terms and Conditions of Independent Directors", url: ind_2 },
    //     { name: "Familiarisation programme for Independent Director 2023-2024", url: ind_3 }
    // ];
    const tabs = [
        // { id: "Subsidiary Financials", label: "Subsidiary Financials" },
        { id: "Policies", label: "Policies" },
        // { id: "Code of Conduct", label: "Code of Conduct" },
        // { id: "Independent Directors", label: "Independent Directors" },
        { id: "Board of Directors", label: "Board of Directors" }
    ];

    const getActiveData = () => {
        if (activeTab === "Policies") return policies;
        // if (activeTab === "Code of Conduct") return codeOfConduct;
        // if (activeTab === "Independent Directors") return Independent;

        // let dataToDisplay = reports;
        // if (selectedCompany === "Sequent Research Limited") dataToDisplay = sequentResearch;
        // else if (selectedCompany === "Sequent Pharmaceuticals Private Limited") dataToDisplay = sequentPharmaceuticals;
        // else if (selectedCompany === "Sequent Anti Biotics Private Limited") dataToDisplay = sequentAntibiotics;
        // // else if (selectedCompany === "Subsidiary Financial") dataToDisplay = reports;
        // else if (selectedCompany === "POLICIES AND FINANCIALS") dataToDisplay = reports;
        // else if (selectedCompany === "Foreign subsidiaries") dataToDisplay = foreignSubsidiaries;
        // else if (selectedCompany === "Elysian Life Sciences Private Limited") dataToDisplay = elysianLifeSciences;
        // else if (selectedCompany === "Alivira Animal Health Limited") dataToDisplay = aliviraAnimalHealth;

        // Apply year and search filter
        // return dataToDisplay.filter(report => {
        //     const searchMatch = !searchQuery || (report.name && report.name.toLowerCase().includes(searchQuery.toLowerCase()));
        //     const yearMatch = selectedYear === "All" || report.year === selectedYear;
        //     return searchMatch && yearMatch;
        // });
    };

    const filteredReports = getActiveData() || [];

    const uniqueYears = useMemo(() => {
        const allYears = ["All", "2025-2026", "2024-2025", "2023-2024", "2022-2023", "2021-2022", "2020-2021", "2019-2020", "2018-2019", "2017-2018", "2016-2017", "2015-2016", "2014-2015"];
        return allYears;
    }, []);

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        setSearchQuery("");
        setSelectedCompany("Subsidiary Financial");
        setSelectedYear("All");
    };

    const handleDownload = (e, url, filename) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (!url) return;

        // Force browser to download the file
        fetch(url)
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.blob();
            })
            .then(blob => {
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = blobUrl;
                // Use the report name as the filename
                link.setAttribute('download', `${filename.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
            })
            .catch(error => {
                console.error('Download failed:', error);
                // Fallback: Open in new window if fetch fails
                window.open(url, '_blank', 'noopener,noreferrer');
            });
    };

    const handlePreview = (e, url) => {
        e.preventDefault();
        e.stopPropagation();
        if (url) window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <div className="financial-page">
            {/* ── HERO ── */}
            <section className="fin-hero">
                <div className="fin-hero-content">
                    <h1>Policies and Subsidiary Financials</h1>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    {/* <p>Sequent Scientific Limited is India's leading animal health company.</p> */}
                </div>
            </section>

            {/* TABS ── */}
            <div className="fin-tabs-strip">
                <nav className="fin-tabs">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            className={`fin-tab ${activeTab === tab.id ? "active" : ""}`}
                            onClick={() => handleTabChange(tab.id)}
                        >
                            <span className="fin-tab-label">{tab.label}</span>
                        </button>
                    ))}
                </nav>
            </div>

            {/* CONTENT */}
            <div className="fin-content">
                <div className="fin-content-inner">
                    {activeTab === "Board of Directors" ? (
                        <>
                            <div className="fin-filter-bar">
                                <div className="fin-filter-left">
                                    <h2 className="fin-section-title">Governing Board</h2>
                                    {/* <span className="fin-result-count">{boardOfDirectors.length} Directors</span> */}
                                </div>
                            </div>

                            <div className="board-grid-wrap">
                                <div className="board-grid">
                                    {boardOfDirectors.map((director, index) => (
                                        <div key={index} className="director-card" onClick={() => setSelectedDirector(director)}>
                                            <div className="director-image-container">
                                                <img src={director.image} alt={director.name} />
                                                <div className="view-bio-overlay">View Bio</div>
                                            </div>
                                            <div className="director-info">
                                                <h3>{director.name}</h3>
                                                <p>{director.role}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="committees-container">
                                <h1 className="main-title">Committees of the Board of The Company</h1>
                                <div className="grid">
                                    {committeesData.map((committee, index) => {
                                        if (committee.members.length === 0) {
                                            return (
                                                <div key={index} className="full-width">
                                                    <h1 className="section-main-title">{committee.title}</h1>
                                                </div>
                                            );
                                        }
                                        return (
                                            <div key={index} className={committee.isFullWidth ? "committee-card full-width" : "committee-card"}>
                                                <h2 className="committee-title">{committee.title}</h2>
                                                <div className="table">
                                                    {committee.members.map((member) => (
                                                        <div key={member.id} className="row">
                                                            <div className="cell index">{member.id}</div>
                                                            <div className="cell name">{member.name}</div>
                                                            <div className="cell role">{member.role}</div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {selectedDirector && (
                                <div className="bio-modal-overlay" onClick={() => setSelectedDirector(null)}>
                                    <div className="bio-modal-content" onClick={(e) => e.stopPropagation()}>
                                        <button className="bio-modal-close" onClick={() => setSelectedDirector(null)}>×</button>
                                        <div className="bio-modal-body">
                                            <div className="bio-modal-image">
                                                <img src={selectedDirector.image} alt={selectedDirector.name} />
                                            </div>
                                            <div className="bio-modal-text">
                                                <h2>{selectedDirector.name}</h2>
                                                <h4 className="role">{selectedDirector.role}</h4>
                                                <div className="bio-divider"></div>
                                                <p>{selectedDirector.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            {/* FILTER BAR */}
                            <div className="fin-filter-bar">
                                <div className="fin-filter-left">
                                    <h2 className="fin-section-title">{tabs.find(t => t.id === activeTab)?.label}</h2>
                                    {/* <span className="fin-result-count">{filteredReports.length} document{filteredReports.length !== 1 ? "s" : ""}</span> */}
                                </div>

                                <div className="fin-filter-right">
                                    {activeTab === "Subsidiary Financials" && (
                                        <>
                                            {/* Search */}
                                            <div className="fin-search-wrapper">
                                                <SearchIcon />
                                                <input
                                                    type="text"
                                                    placeholder="Search documents..."
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                    className="fin-search-input"
                                                />
                                                {searchQuery && (
                                                    <button
                                                        className="fin-search-clear"
                                                        onClick={() => setSearchQuery("")}
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>

                                            <div className="fin-filter-icon">
                                                <FilterIcon />
                                                <span>Filter</span>
                                            </div>
                                            <div className="fin-select-wrapper">
                                                <select
                                                    value={selectedCompany}
                                                    onChange={(e) => setSelectedCompany(e.target.value)}
                                                    className="fin-select"
                                                >
                                                    <option value="Subsidiary Financial">Select Category</option>
                                                    <option value="Subsidiary Financial">Subsidiary Financial</option>
                                                    <option value="Sequent Research Limited">Sequent Research Limited</option>
                                                    <option value="Sequent Pharmaceuticals Private Limited">Sequent Pharmaceuticals Private Limited</option>
                                                    <option value="Sequent Anti Biotics Private Limited">Sequent Anti Biotics Private Limited</option>
                                                    <option value="POLICIES AND FINANCIALS">POLICIES AND FINANCIALS</option>
                                                    <option value="Foreign subsidiaries">Foreign subsidiaries</option>
                                                    <option value="Elysian Life Sciences Private Limited">Elysian Life Sciences Private Limited</option>
                                                    <option value="Alivira Animal Health Limited">Alivira Animal Health Limited</option>
                                                </select>
                                            </div>

                                            <div className="fin-select-wrapper">
                                                <CalendarIcon />
                                                <select
                                                    value={selectedYear}
                                                    onChange={(e) => setSelectedYear(e.target.value)}
                                                    className="fin-select"
                                                >
                                                    {uniqueYears.map(year => (
                                                        <option key={year} value={year}>{year === "All" ? "All Years" : year}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* ACTIVE FILTERS */}
                            {activeTab === "Subsidiary Financials" && (selectedYear !== "All" || selectedCompany !== "Subsidiary Financial" || searchQuery) && (
                                <div className="fin-active-filters">
                                    {selectedCompany !== "Subsidiary Financial" && (
                                        <span className="fin-filter-chip">
                                            {selectedCompany}
                                            <button onClick={() => setSelectedCompany("Subsidiary Financial")}>×</button>
                                        </span>
                                    )}
                                    {selectedYear !== "All" && (
                                        <span className="fin-filter-chip">
                                            {selectedYear}
                                            <button onClick={() => setSelectedYear("All")}>×</button>
                                        </span>
                                    )}
                                    {searchQuery && (
                                        <span className="fin-filter-chip">
                                            Search: "{searchQuery}"
                                            <button onClick={() => setSearchQuery("")}>×</button>
                                        </span>
                                    )}
                                    <button className="fin-clear-all" onClick={() => { setSelectedYear("All"); setSelectedCompany("Subsidiary Financial"); setSearchQuery(""); }}>
                                        Clear all
                                    </button>
                                </div>
                            )}

                            {/* REPORTS GRID */}
                            <div className="fin-reports-grid">
                                {filteredReports.map((report, index) => {
                                    const reportUrl = report.url || report.link;
                                    return (
                                        <div key={index} className="fin-report-card">
                                            {reportUrl && (
                                                <div
                                                    className="fin-card-overlay-link"
                                                    onClick={(e) => handlePreview(e, reportUrl, report.name)}
                                                    aria-label={`Preview ${report.name}`}
                                                    role="button"
                                                    tabIndex={0}
                                                />
                                            )}
                                            <div className="fin-card-top">
                                                <div className="fin-card-icon-wrapper">
                                                    <img src={adobe} alt="PDF" style={{ width: '24px' }} />
                                                </div>
                                                {report.type && (
                                                    <span className="fin-quarter-badge">
                                                        {report.type}
                                                    </span>
                                                )}
                                            </div>

                                            <div className="fin-card-body">
                                                <h4 className="fin-card-title">{report.name}</h4>
                                            </div>
                                            <div className="fin-card-footer">
                                                <span className="fin-card-period">{report.year || "-"}</span>
                                                <button
                                                    className="fin-download-btn"
                                                    title="Download"
                                                    disabled={!reportUrl}
                                                    onClick={(e) => handlePreview(e, reportUrl, report.name)}
                                                >
                                                    <DownloadIcon />
                                                </button>
                                            </div>


                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CorporateGovernance;